import { css } from '@linaria/core'

export const flipIconClass = css`
  transform: rotate(0deg);
  transition: transform 0.25s ease;

  &.flipped {
    transform: rotate(-180deg);
  }
`
